<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="pt-markdown" v-html="content"></div>
</template>

<script>
export default {
  name: 'PtMarkdown',

  model: {
    prop: 'content',
    event: 'input'
  },

  props: {
    content: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" src="./style.scss"></style>
